module.exports = __webpack_public_path__ + "static/media/products.f0a99bec.png";